import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import StorageService from '../services/storageService';
import { KEYS } from '../services/initService';
import { DEFAULT_BUSINESS, formatPriceAmount, mergeBusiness } from '../data/businessDefaults';

const BusinessSettingsContext = createContext(null);

export function BusinessSettingsProvider({ children }) {
  const [business, setBusinessState] = useState(() => mergeBusiness(null));

  const refresh = useCallback(async () => {
    const raw = await StorageService.get(KEYS.BUSINESS);
    setBusinessState(mergeBusiness(raw));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const formatPrice = useCallback((amount) => formatPriceAmount(amount, business), [business]);

  const value = useMemo(
    () => ({
      business,
      formatPrice,
      refresh,
    }),
    [business, formatPrice, refresh]
  );

  return (
    <BusinessSettingsContext.Provider value={value}>
      {children}
    </BusinessSettingsContext.Provider>
  );
}

export function useBusinessSettings() {
  const ctx = useContext(BusinessSettingsContext);
  if (!ctx) {
    return {
      business: mergeBusiness(DEFAULT_BUSINESS),
      formatPrice: (amount) => formatPriceAmount(amount, DEFAULT_BUSINESS),
      refresh: async () => {},
    };
  }
  return ctx;
}
